import React, { Component } from 'react';
import moment from "moment";
import './OpenSensorStatus.css';

import { PieChart } from '@mui/x-charts/PieChart';

import { ReactComponent as SpotSensor} from '../../../icons/sensor_status/SPOT_Sensor_1.svg'
import { ReactComponent as AiVision } from '../../../icons/sensor_status/3D_Sensor_1.svg'
import { ReactComponent as RadarSensor} from '../../../icons/sensor_status/Radar_Sensor_1.svg'
import { ReactComponent as BreathSensor } from '../../../icons/sensor_status/Breath_Pulse_1.svg'

// Define and export the interface for props
export interface OpenSensorStatusModalProps {
  closeSensorStatus: () => void;
}

class OpenSensorStatusModal extends Component<OpenSensorStatusModalProps> {
  render() {
    const { closeSensorStatus } = this.props;
    const sensorData = {
      overall: {
        spotSensor: 321,
        aiVision: 113,
        radarSensor: 76,
        breathPulse: 15
      },
      floors: [        
        { floor: 'B2', spot: '175', camera: '51', radar: '11', breathPulse: '11' },
        { floor: 'B1', spot: '145', camera: '85', radar: '12', breathPulse: '10' },
        { floor: '1F', spot: '123', camera: '85', radar: '10', breathPulse: '13' },
        { floor: '2F', spot: '145', camera: '57', radar: '15', breathPulse: '14' },
        { floor: '3F', spot: '130', camera: '59', radar: '12', breathPulse: '15' },
        { floor: '4F', spot: '135', camera: '54', radar: '13', breathPulse: '16' },
        { floor: '5F', spot: '155', camera: '55', radar: '14', breathPulse: '14' },
        { floor: '6F', spot: '165', camera: '51', radar: '21', breathPulse: '16' },
        { floor: '7F', spot: '145', camera: '85', radar: '12', breathPulse: '13' },
        { floor: '8F', spot: '125', camera: '95', radar: '14', breathPulse: '13' },
        { floor: '9F', spot: '115', camera: '85', radar: '22', breathPulse: '12' },
        // ... other floors
      ]
    };
    return (
      <div className="sensor-modal-backdrop">
        <div className="sensor-modal-content">
          <div className="sensor-modal-header">
            <div style={{fontSize: 20, fontWeight: 900, marginTop: 15}}>시설물 전체 센서 상태 현황</div>
            <span className="sensor-modal-close" onClick={closeSensorStatus}>&times;</span>
          </div>
          <div className="date-container">
            ※ {moment().format("YYYY년 MM월 DD일 HH:mm:ss")}
          </div>
          <div className="sensor-status-overall">
            {/* Individual sensor components will be rendered here */}
            <div className="sensor-block">
              {/* <SpotSensor />                          */}
              <div className='sensor-block body'>
                <div className='sensor-block line'></div>   
                <div className='sensor-title'>
                  <div className='titlegreencircle'></div>
                  <span>SPOT Sensor</span>
                </div>

                <div style={{height: '100px', width: '132px',display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                  <PieChart
                    series={[
                      { 
                        data: [{value : sensorData.overall.spotSensor}],
                        innerRadius: 32,
                        outerRadius: 38,
                        paddingAngle: 5,
                        cornerRadius: 5,
                        startAngle: 0,
                        endAngle: 270,
                        cx: 61,
                        cy: 50,
                      },
                    ]}
                    width={132}
                    height={100}
                    colors={['#F00C0C']}
                  />
                </div>  
              </div>
              <div className="sensor-block spotchart">
              </div>
              <div className="sensor-block spotcharttext">
                <p style={{fontSize: 16, fontWeight: 900}}>{sensorData.overall.spotSensor}</p>
                <p style={{fontSize: 12, fontWeight: 900, marginLeft: 2, alignSelf: "end"}}>개</p>
              </div>
              {/* Include gauge or progress bar component */}
            </div>
            <div className="sensor-block">
              {/* <AiVision /> */}
              <div className='sensor-block body'>
                <div className='sensor-block line'></div>   
                <div className='sensor-title'>
                  <div className='titlegreencircle'></div>
                  <span>3D AI Vision</span>
                </div>

                <div style={{height: '100px', width: '132px',display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                  <PieChart
                    series={[
                      { 
                        data: [{value : sensorData.overall.aiVision}],
                        innerRadius: 32,
                        outerRadius: 38,
                        paddingAngle: 5,
                        cornerRadius: 5,
                        startAngle: 0,
                        endAngle: 315,
                        cx: 61,
                        cy: 50,
                      },
                    ]}
                    width={132}
                    height={100}
                    colors={['#FF542E']}
                  />
                </div>  
              </div>
              <div className="sensor-block aivisiontext">
                <p style={{fontSize: 16, fontWeight: 900}}>{sensorData.overall.aiVision}</p>
                <p style={{fontSize: 12, fontWeight: 900, marginLeft: 2, alignSelf: "end"}}>개</p>
              </div>
              {/* Include gauge or progress bar component */}
            </div>
            <div className="sensor-block">
              {/* <RadarSensor /> */}
              <div className='sensor-block body'>
                <div className='sensor-block line'></div>   
                <div className='sensor-title'>
                  <div className='titlegreencircle'></div>
                  <span>Radar Sensor</span>
                </div>

                <div style={{height: '100px', width: '132px',display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                  <PieChart
                    series={[
                      { 
                        data: [{value : sensorData.overall.radarSensor}],
                        innerRadius: 32,
                        outerRadius: 38,
                        paddingAngle: 5,
                        cornerRadius: 5,
                        startAngle: 0,
                        endAngle: 225,
                        cx: 61,
                        cy: 50,
                      },
                    ]}
                    width={132}
                    height={100}
                    colors={['#58E8E3']}
                  />
                </div>  
              </div>
              <div className="sensor-block radarsensortext">
                <p style={{fontSize: 16, fontWeight: 900 }}>{sensorData.overall.radarSensor}</p>
                <p style={{fontSize: 12, fontWeight: 900, marginLeft: 2, alignSelf: "end"}}>개</p>
              </div>
              {/* Include gauge or progress bar component */}
            </div>
            <div className="sensor-block">
              {/* <BreathSensor /> */}
              <div className='sensor-block body'>
                <div className='sensor-block line'></div>   
                <div className='sensor-title'>
                  <div className='titlegreencircle'></div>
                  <span>Breath/Pulse</span>
                </div>

                <div style={{height: '100px', width: '132px',display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                  <PieChart
                    series={[
                      { 
                        data: [{value : sensorData.overall.breathPulse}],
                        innerRadius: 32,
                        outerRadius: 38,
                        paddingAngle: 5,
                        cornerRadius: 5,
                        startAngle: 0,
                        endAngle: 225,
                        cx: 61,
                        cy: 50,
                      },
                    ]}
                    width={132}
                    height={100}
                    colors={['#97E858']}
                  />
                </div>  
              </div>
              <div className="sensor-block breathpulsetext">
                <p style={{fontSize: 16, fontWeight: 900 }}>{sensorData.overall.breathPulse}</p>
                <p style={{fontSize: 12, fontWeight: 900, marginLeft: 2, alignSelf: "end"}}>개</p>
              </div>
              {/* Include gauge or progress bar component */}
            </div>
          </div>
          <div className="sensor-modal-header">
            <div style={{fontSize: 20, fontWeight: 900}}>층별 센서 설치 현황</div>
            <div className="header-line"></div>
          </div>
          <div className="sensor-status-by-floor">
            {/* Sensors by floor */}
            {sensorData.floors.map((floor, index) => (
              <div key={index} className="floor-status">
                <div className="floor-name">
                  <div style={{textAlign: 'center', alignItems: 'center', justifyItems: 'center', fontWeight: 'bold', fontFamily: 'sans-serif', color: '#03A8A8' }}>
                    <p>{floor.floor}</p>
                  </div>
                </div>
                <div className="sensor-readout spot">
                  <div style={{display: 'flex', paddingLeft: 2,  fontSize: 'small', fontFamily: 'sans-serif'}}>
                    <p>SPOT / </p>
                  </div>                  
                  <div style={{display: 'flex', paddingLeft: 2, color: '#fff',  fontSize: 'small', fontFamily: 'sans-serif'}}>
                    <p>{floor.spot}</p>                    
                  </div>  
                  <div style={{display: 'flex', fontSize: 'x-small', color: '#fff', marginLeft: 2, alignItems: 'flex-start', fontFamily: 'sans-serif'}}>
                    <p>개</p>
                  </div>              
                </div>
                <div className="sensor-readout camera">
                  <div style={{display: 'flex', paddingLeft: 2,  fontSize: 'small', fontFamily: 'sans-serif'}}>
                    <p>Camera / </p>
                  </div>                  
                  <div style={{display: 'flex', paddingLeft: 2, color: '#fff',  fontSize: 'small', fontFamily: 'sans-serif'}}>
                    <p>{floor.camera}</p>
                  </div>
                  <div style={{display: 'flex', fontSize: 'x-small', color: '#fff', marginLeft: 2, alignItems: 'flex-start', fontFamily: 'sans-serif'}}>
                    <p>개</p>
                  </div>                   
                </div>
                <div className="sensor-readout radar">  
                  <div style={{display: 'flex', justifyItems: 'center', alignItems: 'center', paddingLeft: 2,  fontSize: 'small', fontFamily: 'sans-serif'}}>
                    <p>Radar / </p>
                  </div>                
                  <div style={{display: 'flex', justifyItems: 'center', alignItems: 'center', paddingLeft: 2, color: '#fff',  fontSize: 'small', fontFamily: 'sans-serif'}}>
                    <p>{floor.radar}</p>
                  </div>
                  <div style={{display: 'flex', fontSize: 'x-small', color: '#fff', marginLeft: 2, alignItems: 'flex_start', fontFamily: 'sans-serif'}}>
                    <p>개</p>
                  </div>
                </div>
                <div className="sensor-readout breathPulse">
                  <div style={{display: 'flex', paddingLeft: 2,  fontSize: 'small', fontFamily: 'sans-serif'}}>
                    <p>BrearthPulse / </p>
                  </div>                  
                  <div style={{display: 'flex', paddingLeft: 2,  color: '#fff', fontSize: 'small', fontFamily: 'sans-serif'}}>
                    <p>{floor.breathPulse}</p>
                  </div> 
                  <div style={{display: 'flex', fontSize: 'x-small', color: '#fff', marginLeft: 2, alignItems: 'flex_start', fontFamily: 'sans-serif'}}>
                    <p>개</p>
                  </div>
                                   
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default OpenSensorStatusModal;
